export const DATE_FORMATS = {
  agenda: 'agenda',
  short: 'short',
  long: 'long',
  year: 'year',
  advices: 'advices',
  month: 'month',
  monthYear: 'monthYear',
  day: 'day',
  weekdayLong: 'weekdayLong',
  time: 'time',
  timeShort: 'timeShort',
} as const

export type DateFormat = ValueOf<typeof DATE_FORMATS>

// Exemple avec : 1_234_567.89
export const NUMBER_FORMATS = {
  currency: 'currency', // 1 234 567,89 €
  currencyWithSign: 'currencyWithSign', // +1 234 567,89 €
  conciseCurrency: 'conciseCurrency', // 1 234 568 €
  conciseCurrencyWithSign: 'conciseCurrencyWithSign', // +1 234 568 €
  percent: 'percent', // 123 456 789 %
  percent2digits: 'percent2digits', // 123 456 789,00 %
  concisePercent: 'concisePercent', // 123 456 789 %
  parts: 'parts', // 1 234 567,89
  notation: 'notation', // 1 234 567,89
  integer: 'integer', // 1 234 568
  oneDecimal: 'oneDecimal', // 1 234 567,9
  twoDecimal: 'twoDecimal', // 1 234 567,9
} as const

export type NumberFormat = ValueOf<typeof NUMBER_FORMATS>
